// 261005 E1-P1 — thanh kéo đổi độ rộng cột: pointer events + phím mũi tên ±24px + bấm đúp về mặc định.
import React, { useRef, useState } from 'react';

interface Props {
  label: string;
  value: number;
  min: number;
  max: number;
  /** `+1` nếu kéo sang phải làm cột rộng ra (cột trái), `-1` nếu làm hẹp (cột phải). */
  direction: 1 | -1;
  onChange: (px: number) => void;
  onReset: () => void;
}

const STEP = 24;

const Gutter: React.FC<Props> = ({ label, value, min, max, direction, onChange, onReset }) => {
  const [drag, setDrag] = useState(false);
  const start = useRef<{ x: number; w: number } | null>(null);

  const onPointerDown = (e: React.PointerEvent<HTMLDivElement>) => {
    e.currentTarget.setPointerCapture?.(e.pointerId);
    start.current = { x: e.clientX, w: value };
    setDrag(true);
    document.body.classList.add('wb-resizing');
  };
  const onPointerMove = (e: React.PointerEvent<HTMLDivElement>) => {
    if (!start.current) return;
    onChange(start.current.w + direction * (e.clientX - start.current.x));
  };
  const end = (e: React.PointerEvent<HTMLDivElement>) => {
    if (!start.current) return;
    start.current = null;
    setDrag(false);
    document.body.classList.remove('wb-resizing');
    e.currentTarget.releasePointerCapture?.(e.pointerId);
  };
  const onKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'ArrowLeft') { e.preventDefault(); onChange(value - direction * STEP); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); onChange(value + direction * STEP); }
    else if (e.key === 'Home' || e.key === 'Enter') { e.preventDefault(); onReset(); }
  };

  return (
    <div
      className={`wb-gut${drag ? ' wb-drag' : ''}`}
      role="separator" aria-orientation="vertical" tabIndex={0}
      aria-label={`Đổi độ rộng: ${label}`} aria-valuenow={value} aria-valuemin={min} aria-valuemax={max}
      title="Kéo để đổi độ rộng · bấm đúp để về mặc định · phím mũi tên chỉnh ±24px"
      onPointerDown={onPointerDown} onPointerMove={onPointerMove} onPointerUp={end} onPointerCancel={end}
      onDoubleClick={onReset} onKeyDown={onKeyDown}
    />
  );
};

export default Gutter;
